<template>
    <div>
        <h3 ref="title" class="text-dark mb-2 text-2xl">
            <span class="font-bold">Latest reviews</span> for

            <template v-if="manufacturer || model.manufacturer">
                {{ manufacturer ? manufacturer.name : model.manufacturer.name }}
            </template>

            {{ model.name }} tyres
        </h3>

        <p class="text-dark text-sm mb-4">The most recent reviews left by our users</p>

        <MasonryWall :items="reviews"
                     :columns="3"
                     :gap="16"
                     v-slot="slotProps">

            <Transition name="fade" mode="out-in">
                <ReviewCard
                    :key="slotProps.index"
                    :review="slotProps.item"></ReviewCard>

            </Transition>
        </MasonryWall>

        <div class="text-center">
            <AppButton v-if="reviews.length > 0 && currentPage < pageMeta.last_page"
                       :loading="loading"
                       @click="loadMore">
                Load more reviews
            </AppButton>
        </div>
    </div>
</template>

<script>
import ReviewCard from "@/Components/Reviews/ReviewCard";
import MasonryWall from "@/Components/MasonryWall";
import AppButton from "@/Components/AppButton";
import ReviewCardLoader from "@/Components/Loaders/ReviewCardLoader";

export default {
    components: {ReviewCardLoader, AppButton, ReviewCard, MasonryWall},
    props: {
        manufacturer: Object,
        model: Object,
    },
    data() {
        return {
            pageMeta: null,
            reviews: [],
            currentPage: 1,
            loading: true,
            loadingArray: Array.apply(null, Array(6))
        };
    },
    mounted() {
        this.getReviews();
    },
    methods: {
        async getReviews() {
            this.loading = true;

            const response = await axios.get(this.route("models.reviews.index", this.model), {
                params: {
                    page: this.currentPage
                }
            });

            this.pageMeta = response.data;

            if (this.currentPage === 1) {
                this.reviews.splice(0);
            }

            const reviews = [...this.reviews];
            reviews.push(...response.data.data);

            this.reviews = reviews;

            this.loading = false;
        },
        loadMore() {
            this.currentPage++;

            this.getReviews();
        }
    }
};
</script>

<style scoped>

</style>
